<template>
  <v-dialog
    v-model="_value"
    :width="width"
    :eager="eager"
    persistent
    :fullscreen="fullscreen"
    :scrollable="scrollable"
    @keydown.esc="(event) => (!persistent ? closeDialog() : event.stopPropagation())"
  >
    <v-card :class="{ backdrop: _value }" flat :data-test-tooltip="dataTestTooltip">
      <v-card-title class="text-center">
        <img :src="$logos.dialog" alt="XTUR Sp. z o.o." />
        <div class="mx-auto" :style="{ 'max-width': width.slice(0, -2) - 250 + 'px' }">
          <v-icon v-if="!!titleIcon" class="mr-3">{{ titleIcon }}</v-icon>
          {{ _title }}
          <slot name="header"></slot>
        </div>
        <v-btn v-if="!persistent" icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <slot></slot>
      </v-card-text>
      <v-card-actions v-if="actionButtons.length > 0">
        <slot name="bottom"></slot>
        <v-spacer v-if="actionButtons.filter((x) => typeof x.possition != 'undefined').length == 0"></v-spacer>
        <template v-for="(button, index) in actionButtons">
          <v-btn
            :key="JSON.stringify(button)"
            :color="button.color"
            :class="!!button.icon ? 'pl-6 pr-8' : 'px-8'"
            class="green-light-border"
            :outlined="!!button.outlined"
            elevation="0"
            :data-test-tooltip="button.dataTestTooltip"
            small
            @click="
              (clickAction) => {
                buttonClick(clickAction, button);
              }
            "
          >
            <v-icon v-if="!!button.icon" small class="mr-3">{{ button.icon }}</v-icon>
            {{ button.text | capitalize }}
          </v-btn>
          <v-spacer v-if="canAddSpaceBeetween(index)" :key="JSON.stringify(button) + Math.random()"></v-spacer>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { Component, Vue, PropSync, Prop, Watch } from "vue-property-decorator";
import ClickAction from "vuetify/types";
import i18n from "@/plugins/i18n";

export interface DialogButtonInterface {
  text: string;
  color: string;
  icon: string | undefined;
  action: (() => void) | undefined;
  outlined: boolean | undefined;
  possition?: "left" | "right" | undefined;
  dataTestTooltip?: string | undefined;
}

@Component
export default class CustomDialog extends Vue {
  @PropSync("value", { required: true })
  _value?: boolean;
  @PropSync("title", { default: "test" })
  _title?: string;

  @Prop({ default: "650px" })
  width!: string;

  @Prop({ default: false })
  eager!: boolean;

  @Prop({ default: "" })
  titleIcon!: string;

  @PropSync("buttons", {
    required: false,
    default: undefined,
  })
  _buttons?: Array<DialogButtonInterface>;

  @Prop({ default: false })
  persistent!: boolean;

  @Prop({ default: false })
  fullscreen!: boolean;

  @Prop({ default: i18n.t("apply").toString() })
  confirmButtonLabel!: string;

  @Prop({ default: false })
  scrollable!: boolean;

  @Prop({ required: false })
  dataTestTooltip?: string | null;

  defaultButtons: Array<DialogButtonInterface> = [];

  get actionButtons(): Array<DialogButtonInterface> {
    if (typeof this._buttons === "undefined") {
      return this.defaultButtons;
    } else {
      return this._buttons;
    }
  }

  buttonClick(clickAction: ClickAction, button: DialogButtonInterface): void {
    if (typeof button.action === "function") {
      button.action();
    }
  }

  closeDialog(): void {
    this._value = false;
    this.$emit("cancel");
  }

  confirmDialog(): void {
    this.$emit("confirm");
    this._value = false;
  }

  canAddSpaceBeetween(index: number) {
    if (typeof this.actionButtons[index + 1] == "undefined") return false;
    return (
      this.actionButtons[index].possition == "left" &&
      (this.actionButtons[index + 1]?.possition == "right" ||
        typeof this.actionButtons[index + 1]?.possition == "undefined")
    );
  }

  mounted(): void {
    // console.log(this.$route);
    this.defaultButtons = [
      {
        text: i18n.t("close").toString(),
        color: "",
        action: this.closeDialog,
        icon: undefined,
        outlined: true,
      } as DialogButtonInterface,
      {
        text: this.confirmButtonLabel,
        color: "primary",
        action: this.confirmDialog,
        icon: undefined,
      } as DialogButtonInterface,
    ];
  }

  beforeDestroy(): void {
    if (this._value) {
      this.$store.direct.commit.LOWER_DIALOG_COUNT();
    }
    this._value = false;
  }

  @Watch("_value")
  updateDialogCount(val: boolean): void {
    if (val) {
      this.$store.direct.commit.RAISE_DIALOG_COUNT();
    } else {
      this.$store.direct.commit.LOWER_DIALOG_COUNT();
    }
  }
}
</script>

<style scoped></style>
